import React, { useEffect, useState } from 'react';

import { SavePhysicalAtonDialog } from './AtonPhysicalDialog';
import { convertBackendValuesToPhysicalAton } from './atonForm';
import { useGetShareGroups } from '@ais-ui/websockets';
import { useAtonContext } from '../AtonContext';

export const EditPhysicalAton = () => {
  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();
  const [hasLoadedValues, setHasLoadedValues] = useState<boolean>(false);

  const { physicalForm, aton } = useAtonContext();

  useEffect(() => {
    // Check if groups have loaded
    if (!isLoadingGroups && aton) {
      const defaultValues = convertBackendValuesToPhysicalAton(aton, groups);
      physicalForm.reset(defaultValues);
      setHasLoadedValues(true);
    }
  }, [aton, groups, isLoadingGroups, physicalForm]);

  if (!hasLoadedValues) {
    return null;
  }

  return <SavePhysicalAtonDialog mutateType="edit"></SavePhysicalAtonDialog>;
};
